// extracted by mini-css-extract-plugin
export default {"desktop":"Zw5uUC","mobile":"_3NKG-1","title":"_9ILXPe","containerOpen":"_258Yrf","titleText":"rvUNCq","titleArrow":"_2afUK3","content":"_2b6KKE"};